import { useLazyGetPaymentInvoiceQuery } from "../rtk/paymentsHistory/paymentsHistory";

export const useDownloadInvoice = () => {
  const [getPaymentInvoice, { isFetching }] = useLazyGetPaymentInvoiceQuery();

  const downloadInvoice = async (paymentId: number) => {
    try {
      const blob = await getPaymentInvoice(paymentId).unwrap();
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `weenect-${paymentId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  return { downloadInvoice, isFetching };
};
